import { useState } from 'react';
import { FormControl, Input, Text, VStack } from '@chakra-ui/react';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import Modal from '@/trio-ui/Modal';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (keyword: string) => Promise<void>;
};

const AddKeywordsModalComponent = function ({ open, onClose, onSubmit }: Props): JSX.Element {
  const [text, setText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const keyword = text.trim();

  const handleSubmit = async () => {
    if (!keyword) return;
    setSubmitting(true);
    try {
      await onSubmit(keyword);
      setText('');
    } finally {
      setSubmitting(false);
    }
  };

  const body = (
    <VStack spacing={3} align="stretch">
      <Text fontSize="sm" color="gray.500">
        Enter a keyword to track its ranking on Google.
      </Text>
      <FormControl>
        <Input
          placeholder="e.g. hire frontend developer"
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && keyword) handleSubmit(); }}
          autoFocus
          size="md"
        />
      </FormControl>
    </VStack>
  );

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      modalTitle="Add Keyword"
      headerIcon={ManageSearchOutlinedIcon}
      bodyRender={body}
      onConfirmClick={handleSubmit}
      onConfirmLabel={submitting ? 'Adding...' : 'Add Keyword'}
      isButtonDisabled={!keyword || submitting}
      isLoading={submitting}
      isCentered
      size="md"
    />
  );
};

export default AddKeywordsModalComponent;
